<script>
import Hour from "./Hour";

export default {
  name: "Hourly",
  components: {
    hour: Hour,
  },
  props: {
    loc: Object,
  },
  computed: {
    hourly() {
      return this.loc.weather.hourly;
    },
    maxTemp() {
      return Math.max(...this.loc.weather.hourly.map((h) => h.temp));
    },
    minTemp() {
      return Math.min(...this.loc.weather.hourly.map((h) => h.temp));
    },
  }
};
</script>
<template>
  <div class="hourly">
    <h3>Hourly forecast</h3>
    <p>Next 3 days</p>
    <div class="hours">
      <hour v-for="h in hourly" :key="h.dt" :hour="h" :maxTemp="maxTemp" :minTemp="minTemp" />
      <div class="spacer"></div>
    </div>
  </div>
</template>
<style lang="scss">
.hourly {
  h3, p {
    margin: .5rem 1rem;
  }

  p {
    font-weight: bold;
    font-size: .8rem;
    color: var(--light-color);
  }

  .hours {
    display: flex;
    align-items: flex-end;
    overflow-y: scroll;
    padding: 0.5rem;

    .spacer {
      width: 0.5rem;
      height: .5rem;
      flex: 0 0 auto;
    }
  }
}
</style>